
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
import vue from 'vue';
import Vuex from 'vuex';
import VueClipboard from 'vue-clipboard2';
//Components
import JsonEditor from 'vue-json-edit';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import RecruitingIdSearch from './components/RecruitingIdSearch.vue';
import JSONViewer from './components/JSONViewer.vue';
import TimeSpanSelect from './components/TimeSpanSelect';
import LeadSearch from './components/LeadSearch';
import ViewSendToDetails from './components/ViewSendToDetails';
import MasterInput from './components/form-ui/MasterInput';
import ColumnKeyMap from './components/form-ui/ColumnKeyMap';
import StaticValues from './components/form-ui/StaticValues';
import ExportPrevention from './components/form-ui/ExportPrevention';
import LogicFields from './components/form-ui/LogicFields';
import CustomQuestions from './components/form-ui/CustomQuestions';
import RepeatableInput from './components/form-ui/RepeatableInput';
import PasswordInput from './components/form-ui/PasswordInput';
import Ats from './components/ats/Ats';
import SendToDetails from './components/send-to-details/SendToDetails';
import FocusedSendToDetails from './components/send-to-details/FocusedSendToDetails';
import FreeSendToDetails from './components/send-to-details/FreeSendToDetails';
import ModalOverlay from './components/form-ui/ModalOverlay';
import NavTabs from './components/NavTabs';

//Store Modules
import atsStore from './store/ats'
import sendToDetailsStore from './store/send-to-details'
import leadModificationsStore from './store/lead-modifications'
import LogicFieldControls from "./components/form-ui/LogicFieldControls";
import ConfirmBox from "./components/ui-components/ConfirmBox";

window.Vue = vue;

const {ExportToCsv} = require('export-to-csv');

window.fetchExportsByProduct = (title = '', options = {exportType: null, days: null, dateRange: null, selected: []}) => {
    let api_url = '/api/reports/exports-by-product';

    if (options.exportType) {
        api_url = `${api_url}?export-type=${options.exportType}`;
    }

    if (options.days) {
        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&days=${options.days}`
            : `${api_url}?days=${options.days}`;
    }

    if (options.dateRange) {
        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&date-range=${options.dateRange}`
            : `${api_url}?date-range=${options.dateRange}`;
    }

    if (options.selected && options.selected.length) {
        let selected = options.selected

        if (options.exportType) {
            selected = selected.map(id => id.replace(`:${options.exportType}`, ''));
        }

        selected = selected.join(',');

        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&selected=${selected}`
            : `${api_url}?selected=${selected}`;
    }

    fetch(api_url)
        .then(res => res.json())
        .then(function (data) {
            downloadCSV(data.results, title, {
                headers: ['ID', 'Product', 'Exported Leads'],
                showTitle: false,
                autoDate: false,
            });
        });
}

window.fetchExportsBySource = (title = '', options = {exportType: null, days: null, dateRange: null, selected: []}) => {
    let api_url = '/api/reports/exports-by-source';

    if (options.exportType) {
        api_url = `${api_url}?export-type=${options.exportType}`;
    }

    if (options.days) {
        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&days=${options.days}`
            : `${api_url}?days=${options.days}`;
    }

    if (options.dateRange) {
        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&date-range=${options.dateRange}`
            : `${api_url}?date-range=${options.dateRange}`;
    }

    if (options.selected && options.selected.length) {
        let selected = options.selected

        if (options.exportType) {
            selected = selected.map(id => id.replace(`:${options.exportType}`, ''));
        }

        selected = selected.join(',');

        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&selected=${selected}`
            : `${api_url}?selected=${selected}`;
    }

    fetch(api_url)
        .then(res => res.json())
        .then(function (data) {
            downloadCSV(data.results, title, {
                headers: ['ID', 'Source', 'Exported Leads'],
                showTitle: false,
                autoDate: false,
            });
        });
}

window.fetchExportsByRpoJob = (title = '', options = {days: null, dateRange: null, selected: []}) => {
    let api_url = '/api/reports/exports-by-rpo-job';

    if (options.days) {
        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&days=${options.days}`
            : `${api_url}?days=${options.days}`;
    }

    if (options.dateRange) {
        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&date-range=${options.dateRange}`
            : `${api_url}?date-range=${options.dateRange}`;
    }

    if (options.selected && options.selected.length) {
        let selected = options.selected

        selected = selected.join(',');

        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&selected=${selected}`
            : `${api_url}?selected=${selected}`;
    }

    fetch(api_url)
        .then(res => res.json())
        .then(function (data) {
            downloadCSV(data.results, title, {
                headers: [
                    'Total Exported Leads',
                    'Reach Jobs Exported Leads',
                    'Non Reach Jobs Exported Leads',
                    'Client ID',
                    'Client Name',
                    'Export Details ID',
                    'Job ID',
                    'IntKey',
                    'Req',
                    'External Job ID',
                    'Position Type',
                    'Position Title',
                    'Location',
                    'Post Type',
                    'Status',
                ],
                showTitle: false,
                autoDate: false,
            });
        });
}

window.fetchExportsByExportDetails = (title = '', options = {exportType: null, days: null, dateRange: null, selected: []}) => {
    let api_url = '/api/reports/exports-by-export-details';

    if (options.exportType) {
        api_url = `${api_url}?export-type=${options.exportType}`;
    }

    if (options.days) {
        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&days=${options.days}`
            : `${api_url}?days=${options.days}`;
    }

    if (options.dateRange) {
        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&date-range=${options.dateRange}`
            : `${api_url}?date-range=${options.dateRange}`;
    }

    if (options.selected && options.selected.length) {
        let selected = options.selected

        if (options.exportType) {
            selected = selected.map(id => id.replace(`:${options.exportType}`, ''));
        }

        selected = selected.join(',');

        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&selected=${selected}`
            : `${api_url}?selected=${selected}`;
    }

    fetch(api_url)
        .then(res => res.json())
        .then(function (data) {
            downloadCSV(data.results, title, {
                headers: ['Export Details ID', 'SCN Match', 'Client ID', 'Client Name', 'Integration', 'SendTo', 'Exported Leads'],
                showTitle: false,
                autoDate: false,
            });
        });
}

window.fetchExportsByClient = (title = '', options = {exportType: null, days: null, dateRange: null, selected: []}) => {
    let api_url = '/api/reports/exports-by-client';

    if (options.exportType) {
        api_url = `${api_url}?export-type=${options.exportType}`;
    }

    if (options.days) {
        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&days=${options.days}`
            : `${api_url}?days=${options.days}`;
    }

    if (options.dateRange) {
        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&date-range=${options.dateRange}`
            : `${api_url}?date-range=${options.dateRange}`;
    }

    if (options.selected && options.selected.length) {
        let selected = options.selected

        if (options.exportType) {
            selected = selected.map(id => id.replace(`:${options.exportType}`, ''));
        }

        selected = selected.join(',');

        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&selected=${selected}`
            : `${api_url}?selected=${selected}`;
    }

    fetch(api_url)
        .then(res => res.json())
        .then(function (data) {
            downloadCSV(data.results, title, {
                headers: ['Client ID', 'Client Name', 'Integration', 'SendTo', 'Exported Leads'],
                showTitle: false,
                autoDate: false,
            });
        });
}

window.fetchExportsByIntegration = (title = '', options = {days: null, dateRange:null, exportType: null}) => {
    let api_url = '/api/reports/exports-by-integration';

    if (options.exportType) {
        api_url = `${api_url}?export-type=${options.exportType}`;
    }

    if (options.days) {
        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&days=${options.days}`
            : `${api_url}?days=${options.days}`;
    }

    if (options.dateRange) {
        api_url = api_url.indexOf('?') > -1
            ? `${api_url}&date-range=${options.dateRange}`
            : `${api_url}?date-range=${options.dateRange}`;
    }

    fetch(api_url)
        .then(res => res.json())
        .then(function (data) {
            downloadCSV(data.results, title, {
                headers: ['Integration', 'SendTo', 'Exported Leads', 'Last Export'],
                showTitle: false,
                autoDate: false,
            });
        });
}

window.fetchExportLogs = (title = '', options = {}) => {
    jQuery.post('/api/export-logs', options).then(function (res) {
        downloadCSV(res.data, title, {
            headers: res.csvHeaders,
            showTitle: false,
            autoDate: true,
        });
    });
}

window.downloadCSV = (data, title = '', options = {autoDate: true}) => {
    let filename = typeof options.filename !== 'undefined'
        ? options.filename
        : `${title}`.toLowerCase().replace(/[\W_]+/g, '-');

    if (typeof options.autoDate === 'undefined' || options.autoDate) {
        const date = new Date();
        const dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

        filename = `${filename}_${dateString}`;
        title = `${title} (${dateString})`;
    }

    const csvExporter = new ExportToCsv({
        fieldSeparator: typeof options.fieldSeparator !== 'undefined' ? options.fieldSeparator : ',',
        quoteStrings: typeof options.quoteStrings !== 'undefined' ? options.quoteStrings : '"',
        decimalSeparator: typeof options.decimalSeparator !== 'undefined' ? options.decimalSeparator : '.',
        showLabels: typeof options.showLabels !== 'undefined' ? options.showLabels : true,
        showTitle: typeof options.showTitle !== 'undefined' ? options.showTitle : true,
        useTextFile: typeof options.useTextFile !== 'undefined' ? options.useTextFile : false,
        useBom: typeof options.useBom !== 'undefined' ? options.useBom : false,
        useKeysAsHeaders: typeof options.useKeysAsHeaders !== 'undefined' ? options.useKeysAsHeaders : false,
        headers: typeof options.headers !== 'undefined' ? options.headers : false,
        title: title,
        filename: filename,
    });
console.log('ver 0.2.1');
    csvExporter.generateCsv(data);
}

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(JsonEditor);
Vue.use(Vuex);
Vue.use(VueClipboard);
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
Vue.component('recruiting-search', RecruitingIdSearch);
Vue.component('json-viewer', JSONViewer);
Vue.component('time-span-select', TimeSpanSelect);
Vue.component('lead-search', LeadSearch);
Vue.component('ViewSendToDetails', ViewSendToDetails);
Vue.component('MasterInput', MasterInput)
Vue.component('ColumnKeyMap', ColumnKeyMap);
Vue.component('LogicFields', LogicFields);
Vue.component('CustomQuestions', CustomQuestions);
Vue.component('LogicFieldControls', LogicFieldControls);
Vue.component('ConfirmBox', ConfirmBox);
Vue.component('StaticValues', StaticValues);
Vue.component('ExportPrevention', ExportPrevention);
Vue.component('RepeatableInput', RepeatableInput);
Vue.component('PasswordInput', PasswordInput);
Vue.component('Ats', Ats);
Vue.component('SendToDetails', SendToDetails);
Vue.component('FocusedSendToDetails', FocusedSendToDetails);
Vue.component('FreeSendToDetails', FreeSendToDetails);
Vue.component('ModalOverlay', ModalOverlay);
Vue.component('NavTabs', NavTabs);

//Don't do vue app on documentation pages because documentation includes
// double curly braces sometimes that can't be escaped from the markdown
if(!window.location.pathname.startsWith('/documentation')){
    const app = new Vue({
        el: '#app',
        store : new Vuex.Store({
            modules:{
                ats: atsStore,
                sendToDetails: sendToDetailsStore,
                leadModifications: leadModificationsStore
            }
        }),
        methods: {
            emitToLivewire(key, value) {
                Livewire.emit(key, value)
            },
            handleLivewireValue(value) {
                console.log(value)
                return [];
            },
            setInputWatcher() {
                document.onreadystatechange = () => {
                    if (document.readyState === 'complete') {
                        setTimeout(() => {
                            const thisVue = this;

                            window.loadedValues = this.collectLoadedValues();

                            if (window.inputChanges === undefined) {
                                window.inputChanges = {};
                                window.deleted = {};
                                window.disabled = {};
                            }

                            this.listenForFieldUpdates();
                            this.listenForDisables();
                            this.listenForDeletes();
                            this.listenForMoves();

                            $(document).on('submit', '[data-w-form]', function () {
                                thisVue.insertUserLog($(this).attr('data-w-form'));
                            });

                            $(document).on('click', '[data-w-submit]', function (e) {
                                thisVue.insertUserLog($(this).attr('data-w-submit'));
                            });
                        }, 1000);
                    }
                };
            },
            collectLoadedValues() {
                const $inputsAndSelects = $("[data-w-input]");
                let loadedValues = {};

                $inputsAndSelects.each(function () {
                    const inputKey = $(this).attr('data-w-input');

                    if (typeof inputKey === 'undefined') return;

                    loadedValues[inputKey] = $(this).val();
                });

                return loadedValues;
            },
            listenForFieldUpdates() {
                const thisVue = this;

                $(document).on('change input', "[data-w-input]", function (e) {
                    const key = $(this).attr('data-w-input');
                    const val = $(this).val();

                    if (!key) {
                        return;
                    }

                    thisVue.updateInputChanges(key, val);
                });

                window.addEventListener('field-updates', event => {
                    for (const [key, val] of Object.entries(event.detail)) {
                        this.updateInputChanges(key, val);
                    }
                });
            },
            updateInputChanges(key, val) {
                let values = {};
                let $input = $(`input[data-w-input='${key}']`);

                if ($input.attr('type') === 'checkbox') {
                    values = {
                        new: $input.checked ? 'on' : 'off',
                        old: $input.checked ? 'off' : 'on',
                    };
                } else {
                    values = {
                        new: typeof val === 'object' ? val.toString() : val,
                        old: typeof loadedValues[key] === 'object'
                            ? loadedValues[key].toString()
                            : loadedValues[key] || null,
                    };
                }


                if (values.old !== values.new) {
                    inputChanges[key] = values;
                } else {
                    delete inputChanges[key];
                }
            },
            listenForDeletes() {
                const thisVue = this;

                $(document).on('click', "[data-w-delete-key]", function (e) {
                    const key = $(this).attr('data-w-delete-key');
                    const value = $(this).attr('data-w-delete-value');

                    if (!key) {
                        return;
                    }

                    thisVue.updateDeleted(key, value);
                });

                window.addEventListener('bulk-delete', event => {
                    for (const [key, val] of Object.entries(event.detail)) {
                        this.updateDeleted(key, val);
                    }
                });
            },
            updateDeleted(key, value) {
                deleted[key] = {
                    new: 'deleted',
                    old: typeof value === 'object' ? value.toString() : value,
                };

                this.filterChildrenAfterDelete(disabled, key);
                this.filterChildrenAfterDelete(inputChanges, key);
            },
            listenForMoves() {
                const thisVue = this;

                $(document).on('click', "[data-w-move-key]", function (e) {
                    const key = $(this).attr('data-w-move-key');
                    const index = $(this).attr('data-w-move-index');
                    const direction = $(this).attr('data-w-move-direction');

                    if (!key) {
                        return;
                    }

                    thisVue.updateChildrenKeyOnMove(key, index, direction);
                });
            },
            listenForDisables() {
                $(document).on('click', "[data-w-disable-key]", function (e) {
                    const key = $(this).attr('data-w-disable-key');
                    const value = $(this).attr('data-w-disable-value');

                    disabled[key] = {
                        new: value === 'true' ? 'false' : 'true',
                    };
                });

                window.addEventListener('bulk-status', event => {
                    for (const [key, val] of Object.entries(event.detail)) {
                        disabled[key] = {
                            new: val === 'true' ? 'false' : 'true',
                        };
                    }
                });
            },
            insertUserLog(inputPrefix) {
                const keysToRemove = inputPrefix.length
                    ? Object.keys(inputChanges).filter(key => !key.startsWith(inputPrefix))
                    : [];

                if (keysToRemove.length) {
                    keysToRemove.forEach(key => delete inputChanges[key]);
                }

                if ('password-current' in inputChanges) {
                    inputChanges['password-current'] = {'old': null, 'new': 'changed'};
                    inputChanges['password-new'] = {'old': null, 'new': 'changed'};
                }

                if (Object.keys(inputChanges).length === 0) return;

                axios.post('/api/logs/users/add', {
                    data: JSON.stringify(inputChanges),
                    deleted: Object["deleted"] !== undefined && Object.keys(deleted).length ? JSON.stringify(deleted) : null,
                    disabled: Object["disabled"] !== undefined && Object.keys(disabled).length ? JSON.stringify(disabled) : null,
                }).then(() => {
                    window.inputChanges = {};
                    window.disabled = {};
                    window.deleted = {};
                });
            },
            filterChildrenAfterDelete(objToUpdate, deletedKey) {
                let updatedKeys = Object.keys(objToUpdate);

                updatedKeys = updatedKeys.filter(key => key.startsWith(deletedKey));

                for (const key of updatedKeys) {
                    delete objToUpdate[key];
                }

                return objToUpdate;
            },
            updateChildrenKeyOnMove(movedKey, index, direction) {
                const updatedKeys = Object.keys(inputChanges).filter(key => key.startsWith(movedKey));
                const newIndex = direction === 'up' ? parseInt(index) - 1 : parseInt(index) + 1;
                const newKey = movedKey.replace(/\.\d+$/, `.${newIndex}`);
                const existingKeys = Object.keys(inputChanges).filter(key => key.startsWith(newKey));
                let tempObject = {};

                for (const key of existingKeys) {
                    tempObject[key.replace(newKey, movedKey)] = inputChanges[key];
                }

                for (const key of updatedKeys) {
                    tempObject[key.replace(movedKey, newKey)] = inputChanges[key];
                }

                for (const [key, val] of Object.entries(tempObject)) {
                    delete inputChanges[key];

                    inputChanges[key] = val;
                }
            }
        },
        mounted() {
            this.setInputWatcher();
        }
    });
}

